import styled from "styled-components";

const FilterContainer = styled.div`
    color: #757575;
    display: flex;
`;
export default FilterContainer;
